// frontend_react/src/context/AllProviders.jsx

import React from "react";

import { LoginProvider } from "./LoginContext";
import { DataProvider } from "./DataContext";
import { CartProvider } from "./CartContext";
import { ReceiptProvider } from "./ReceiptContext";
import { CompanyProvider } from "./CompanyContext";
import { AdminScopeProvider } from "./AdminScopeContext";
import { CustomerPortalProvider } from "./CustomerPortalContext";
import AuthReadyGate from "./AuthReadyGate";

export default function AllProviders({ children }) {
  return (
    <LoginProvider>
      <AuthReadyGate>
        <CompanyProvider>
          <AdminScopeProvider>
            <DataProvider>
              <CartProvider>
                <ReceiptProvider>
                  <CustomerPortalProvider>
                    {children}
                  </CustomerPortalProvider>
                </ReceiptProvider>
              </CartProvider>
            </DataProvider>
          </AdminScopeProvider>
        </CompanyProvider>
      </AuthReadyGate>
    </LoginProvider>
  );
}